var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66669 3.33329C8.66669 2.9651 8.36821 2.66663 8.00002 2.66663C7.63183 2.66663 7.33335 2.9651 7.33335 3.33329V7.33329H3.33335C2.96516 7.33329 2.66669 7.63177 2.66669 7.99996C2.66669 8.36815 2.96516 8.66663 3.33335 8.66663H7.33335V12.6666C7.33335 13.0348 7.63183 13.3333 8.00002 13.3333C8.36821 13.3333 8.66669 13.0348 8.66669 12.6666V8.66663H12.6667C13.0349 8.66663 13.3334 8.36815 13.3334 7.99996C13.3334 7.63177 13.0349 7.33329 12.6667 7.33329H8.66669V3.33329Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.a6c2e3592b7be2009e31627472784b99.svg";
export { ForwardRef as ReactComponent };